export default "__VITE_ASSET__CHtwtk5g__"